<p>attendances-view works!</p>
